import { CurrencyExchangeRatesApi } from '@/types';
import { fetchFromApi } from './fetchFromApi';

export const fetchCurrencyExchangeRates = () =>
  fetchFromApi<CurrencyExchangeRatesApi>('currencyExchangeRates');
